import { render, staticRenderFns } from "./DataViewSidebarLetters.vue?vue&type=template&id=0f331f53&scoped=true&"
import script from "./DataViewSidebarLetters.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarLetters.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarLetters.vue?vue&type=style&index=0&id=0f331f53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f331f53",
  null
  
)

export default component.exports